import {toast} from '@wandb/weave/common/components/elements/Toast';
import {Button, ButtonProps} from '@wandb/weave/components';
import copyToClipboard from 'copy-to-clipboard';
import React, {useCallback, useMemo} from 'react';
import {useReadOnly} from 'slate-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

import {CustomElement} from '../../custom-slate';
import {useReportContext} from '../../state/reports/context';
import {removeHashFromURL} from '../../util/urls';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {getDeepLinkId} from './util';

type StyledLinkButtonProps = {top?: number; left?: number};
type CopyLinkButtonProps = ButtonProps &
  StyledLinkButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement>;

export const StyledLinkButton = styled(Button)<StyledLinkButtonProps>`
  position: absolute;
  top: ${p => p.top ?? 0}px;
  left: ${p => p.left ?? 0}px;
  visibility: hidden;
`;

export const deepLinkBlockWrapperStyles = css`
  position: relative;
  padding-left: 36px;
  left: -36px;
  &:hover ${StyledLinkButton} {
    visibility: visible;
  }
`;

export const CopyLinkButton = (props: CopyLinkButtonProps) => {
  return (
    <StyledLinkButton
      twWrapperStyles={{display: 'flex'}}
      size="small"
      icon="link-alt"
      variant="ghost"
      {...props}
    />
  );
};

export const useDeepLinkBlock = (element: CustomElement) => {
  const deepLinkId = useMemo(() => getDeepLinkId(element), [element]);
  const readOnly = useReadOnly();
  const {disableCopyLinkToSection} = useReportContext();

  const isCopyLinkAllowed =
    !!deepLinkId && readOnly && !disableCopyLinkToSection;

  const onCopyLink = useCallback(() => {
    const deepUrl = removeHashFromURL(window.location.href) + '#' + deepLinkId;
    copyToClipboard(deepUrl);
    toast('Copied link to section');
  }, [deepLinkId]);

  return {deepLinkId, isCopyLinkAllowed, onCopyLink};
};
